
      module.exports = {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"width":"20","height":"19","fill":"none","xmlns":"http://www.w3.org/2000/svg"}, attrs),
              ...rest,
            },
            children.concat([_c('path',{attrs:{"d":"M19.414 1.371h-2.567c.01-.27.015-.541.015-.814 0-.308-.262-.557-.586-.557H3.724c-.324 0-.586.25-.586.557 0 .273.005.544.014.814H.586c-.324 0-.586.25-.586.557 0 2.494.686 4.847 1.932 6.626 1.232 1.758 2.872 2.767 4.644 2.865.402.416.827.754 1.269 1.012v2.475h-.983c-1.188 0-2.155.918-2.155 2.047v.934h-.042c-.323 0-.586.249-.586.556 0 .308.263.557.586.557h10.67c.323 0 .586-.25.586-.557 0-.307-.263-.556-.586-.556h-.042v-.934c0-1.129-.967-2.047-2.155-2.047h-.983V12.43a5.954 5.954 0 001.269-1.012c1.772-.098 3.412-1.107 4.644-2.865C19.314 6.775 20 4.422 20 1.928c0-.308-.262-.557-.586-.557zM2.908 7.937C1.88 6.47 1.276 4.551 1.184 2.485h2.034c.211 2.54.839 4.888 1.82 6.752.156.297.32.578.49.842-.975-.35-1.877-1.08-2.62-2.142zm14.184 0c-.743 1.061-1.645 1.792-2.62 2.142.17-.264.334-.545.49-.842.981-1.864 1.609-4.212 1.82-6.752h2.034c-.092 2.066-.696 3.985-1.724 5.452z","fill":"#FFDC26"}})])
          )
        }
      }
    